import { useAuth } from '../context/AuthContext';
import { API } from './axios';
import { postUserProfile } from './me';

const postApplicant = async (newApplicant, user) => {
  try {
    const payload = transformApplicantPayload(
      newApplicant,
      user.id,
      user.email
    );
    const res = await API.post('/applicants', payload);
    return res.data;
  } catch (err) {
    console.error(
      '❌ Failed to submit applicant:',
      err.response?.data || err.message
    );
    throw err;
  }
};

export { postApplicant };

const transformApplicantPayload = (newApplicant, userId, userEmail) => {
  const availabilityArray = Object.entries(newApplicant.availability).map(
    ([day, slots]) => ({
      day,
      ...slots,
    })
  );

  return {
    data: {
      user: userId,
      email: userEmail,
      qualifications: newApplicant.qualifications,
      personalInfo: newApplicant.personalInformation,
      experience: newApplicant.workExperience,
      availability: availabilityArray,
      agreements: newApplicant.agreements,
      applicationStatus: 'applicationSubmitted',
    },
  };
};
